<template>
    <LineChartGenerator
        :chart-data="chartData"
        :chart-options="chartOptions"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        css-classes="chartLine"
        :styles="styles"
        :width="width"
        :height="height"
        ref="canvas"
    />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import { Chart as ChartJS, registerables } from 'chart.js';
ChartJS.register(...registerables);

ChartJS.defaults.color = '#ffffff';
ChartJS.defaults.font.size = 14;

export default {
	name: "LineChart",
	components: {
		LineChartGenerator
	},
	props: {
		chartData: Object,
		chartOptions: Object,
		chartId: {
			type: String,
			default: 'line-chart'
		},
		datasetIdKey: {
			type: String,
			default: 'label'
		},
		width: {
			type: Number,
			default: 400
		},
		height: {
			type: Number,
			default: 470
		},
		cssClasses: {
			default: '',
			type: String
		},
		styles: {
			type: Object,
			default: () => {}
		},
		plugins: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style scoped lang="scss">
@import "LineChart";
</style>
